import React, { useState } from "react";
import axios from "axios";

const LocationSearch = ({ placeholder, onSelect }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const searchLocation = async (value) => {
    setQuery(value);

    if (value.length < 3) {
      setResults([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: value,
            format: "json",
            addressdetails: 1,
            limit: 5,
          },
        }
      );

      setResults(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={query}
        placeholder={placeholder}
        onChange={(e) => searchLocation(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
        }}
      />

      {results.length > 0 && (
        <div
          style={{
            border: "1px solid #ccc",
            background: "#fff",
            position: "absolute",
            width: "100%",
            zIndex: 999,
          }}
        >
          {results.map((item, index) => (
            <div
              key={index}
              style={{
                padding: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                setQuery(item.display_name);
                setResults([]);
                onSelect(item);
              }}
            >
              {item.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationSearch;